import { canAnyIn, canIn, type Me, type Needs } from "./can.ts";

/* ──────────────────────────────────────────────────────────────────────────
   Where the home address takes someone (Jay, 2026-09-30): Now when they may
   see it; otherwise the first page in the bar they can open, in the bar's own
   order, then the admin pages, then Settings, which everyone has. No React
   here, so the rule is tested in Node.
   ────────────────────────────────────────────────────────────────────────── */

export const NOW_NEEDS = "signet.now:view";

const ADMIN: { to: string; needs: string }[] = [
  { to: "/people", needs: "signet.people:view" },
  { to: "/roles", needs: "signet.roles:view" },
  { to: "/usage", needs: "signet.usage:view" },
];

/** A module's place in the bar, as far as landing cares. "Coming soon" entries have no address. */
type Nav = { to?: string; needs?: Needs };

export function landingFor(me: Me | undefined, modules: { nav?: Nav | object }[]): string {
  if (canIn(me, NOW_NEEDS)) return "/";
  for (const mod of modules) {
    const nav = mod.nav as Nav | undefined;
    if (nav?.to && nav.needs && canAnyIn(me, nav.needs)) return nav.to;
  }
  return ADMIN.find((page) => canIn(me, page.needs))?.to ?? "/settings";
}
